import React, { useEffect, useRef, useState } from 'react';
import * as echarts from 'echarts';
import { useGetStoreInfractionsStatsManual } from '../../../hooks/useGetStoreInfractionsStats';

export const ItemsInfractionsChart = (props: {}) => {
	const chartRef = useRef(null);
	const chartInstance = useRef(null);
	const { getStoreInfractionsStats, data } = useGetStoreInfractionsStatsManual();
	const [option, setOption] = useState({
		title: {
			text: 'Correcciones de infracciones',
			left: 'center',
			top: 20
		},
		tooltip: {
			trigger: 'item'
		},
		legend: {
			bottom: 0,
			right: 'center'
		},
		series: [
			{
				name: 'Proceso de corrección de infracciones',
				type: 'pie',
				radius: ['70%', '40%'],
				avoidLabelOverlap: true,
				itemStyle: {
					borderRadius: 10,
					borderColor: '#f3f4f6',
					borderWidth: 2,
				},
				label: {
					show: false,
				},
				labelLine: {
					show: false
				},
				data: [
					{ value: 0, name: `Sin infracciones`, itemStyle: { color: '#6941C6' } },
					{ value: 0, name: 'Infracciones de calidad', itemStyle: { color: '#9E77ED' } },
					{ value: 0, name: 'Infracciones de contenido', itemStyle: { color: '#C6B9E8' } }
				]
			}
		]
	});

	useEffect(() => {
		getStoreInfractionsStats();
	}, []);

	useEffect(() => {
		if (data?.getStoreInfractionsStats) {
			const stats = data.getStoreInfractionsStats;
			setOption(prev => ({
				...prev,
				series: [{
					...prev.series[0],
					data: [
						{ value: stats.noInfractions, name: 'Sin infracciones', itemStyle: { color: '#6941C6' } },
						{ value: stats.qualityInfractions, name: 'Infracciones de calidad', itemStyle: { color: '#9E77ED' } },
						{ value: stats.contentInfractions, name: 'Infracciones de contenido', itemStyle: { color: '#C6B9E8' } }
					]
				}]
			}));
		}
	}, [data]);

	useEffect(() => {
		if (chartRef.current && !chartInstance.current) {
			// @ts-ignore
			chartInstance.current = echarts.init(chartRef.current);
		}
		
		if (chartInstance.current) {
			// @ts-ignore
			chartInstance.current.setOption(option);
		}
	}, [option]);

	return <div><div ref={chartRef} style={{ width: 320, height: 390, marginTop: -20, marginLeft: -25 }} /></div>;
}
